import {IMessageType} from "../../index";
import {nsMessages} from "./fn";
import getMainType = nsMessages.getMainType;
import getSubType = nsMessages.getSubType;
import getMinorType = nsMessages.getMinorType;
import message_type_staticHtml from './message-type-static.html?raw';

export let template = message_type_staticHtml;

interface IParams {
    messageType: IMessageType
}

export class viewModel {
    private mainType: any;
    private subType: any;
    private minorType: any;
    constructor(params: IParams) {
        this.mainType = getMainType(params.messageType.name);
        this.subType = getSubType(params.messageType.name);
        this.minorType = getMinorType(params.messageType.name);
    }
}
